export interface VolunteeringState {
  volunteering_list:any[],
  loading: boolean
}

export const FETCH_VOLUNTEERING_LIST_REQUESTED = "FETCH_VOLUNTEERING_LIST_REQUESTED";
export const FETCH_VOLUNTEERING_LIST_SUCCEEDED = "FETCH_VOLUNTEERING_LIST_SUCCEEDED";
export const FETCH_VOLUNTEERING_LIST_FAILED = "FETCH_VOLUNTEERING_LIST_FAILED";

